export const IconsSize = {

    desktop: {
        xs: "16",
        sm: "20",
        md: "24",
        lg: "32",
        xl: "40",
    },

    videowall: {
        xxs: '0.418vw',// In Cascais 32.0px
        xs: "0.625vw", // In Cascais 48.0px
        sm: "0.678vw", // In Cascais 52.0px                               
        md: "0.834vw",// In Cascais 64.0px
        lg: "1.146vw",// In Cascais 88.0px
        xl: "1.25vw",// In Cascais 96.0px
        xxl: "1.355vw",// In Cascais 104.0px
    }
}

export const IconsSizeWithBg = {
  
    desktop: {
        xxs: '8', //nao definido em ui, poderºa ser acrescentado valor menor no futuro
        xs: "8",
        sm: "12",
        md: "16",
        lg: "24",
        xl: "32",
        xxl: "32" //nao definido em ui, poderºa ser acrescentado valor maior no futuro
    },

    videowall: {
        xxs: '0.318vw',
        xs: "0.418vw", 
        sm: "0.625vw",                               
        md: "0.678vw",
        lg: "0.834vw",
        xl: "1.146vw",
        xxl: "1.25vw",
    }
}